import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import clients from './clients.js';
import './ClientsList.css'; // Import the new CSS file

const ClientsList = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.matchMedia('(max-width: 700px)').matches);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="clients-page">
      <h1>My Clients</h1>
      
      <div className="clients-header">
        <div className="search-filter">
          <input type="text" placeholder="Search clients..." className="client-search" />
          <select className="client-filter">
            <option value="all">All Clients</option>
            <option value="active">Active Clients</option>
            <option value="inactive">Inactive Clients</option>
          </select>
        </div>
        <button className="add-client-btn">+ Add New Client</button>
      </div>
      
      {isMobile ? (
        <div className="clients-list-mobile">
          {clients.map(client => (
            <div
              key={client.id}
              className={`clientdashboard-list-item ${client.status.toLowerCase().replace(' ', '-')}`}
              onClick={() => window.location.href = `/clients/${client.id}/dashboard`}
            >
              <div className="clientdashboard-avatar-small">
                {client.name.charAt(0)}
              </div>
              <div className="clientdashboard-info">
                <div className="clientdashboard-name">{client.name}</div>
                <div className="clientdashboard-program">{client.program}</div>
                <div>
                  <span className={`status-badge ${client.status.toLowerCase().replace(' ', '-')}`}>
                    {client.status}
                  </span>
                  <span className="clientdashboard-join-date">
                    Joined: {new Date(client.joinDate).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="clients-table-container fogged-card">
          <table className="clients-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Program</th>
                <th>Status</th>
                <th>Join Date</th>
              </tr>
            </thead>
            <tbody>
              {clients.map(client => (
                <tr 
                  key={client.id}
                  onClick={() => window.location.href = `/clients/${client.id}/dashboard`}
                  className={`clientdashboard-row ${client.status.toLowerCase().replace(' ', '-')}`}
                >
                  <td className="client-name">
                    <div className="clientdashboard-avatar-small">{client.name.charAt(0)}</div>
                    {client.name}
                  </td>
                  <td>{client.program}</td>
                  <td>
                    <span className={`status-badge ${client.status.toLowerCase().replace(' ', '-')}`}>
                      {client.status}
                    </span>
                  </td>
                  <td>{new Date(client.joinDate).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ClientsList;